import { render, staticRenderFns } from "./BookSidebar.vue?vue&type=template&id=3a799300&scoped=true&"
import script from "./BookSidebar.vue?vue&type=script&lang=js&"
export * from "./BookSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BookSidebar.vue?vue&type=style&index=0&id=3a799300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a799300",
  null
  
)

export default component.exports